import styled from "styled-components";
import { AvatarHoverStyles } from "@sonder/ui/source/styled/fragments/Avatar";
import { MultiAvatar } from "@sonder/ui/source/styled/fragments/MultiAvatar";
import { PlainButton } from "@sonder/ui/source/styled/fragments/PlainButton";
import { borders, colors } from "@sonder/ui/source/styled/theme";

export const LabeledIconButton = styled(PlainButton)`
  background: ${colors.white};
  border-radius: 0.2rem;
  border: 1px solid ${colors.white};
  box-sizing: border-box;
  color: ${colors.gray4};
  height: 2.7rem;
  max-width: 13rem;

  display: inline-flex;
  padding: 0 0.85rem;
  align-items: center;

  > svg,
  > span:first-child {
    margin-right: 0.85rem;
  }

  ${MultiAvatar} {
    margin-right: 1rem;
  }

  &:disabled {
    opacity: 0.5;
  }

  ${AvatarHoverStyles}
  &:hover:not(:disabled) {
    background: ${colors.grayF6};
    border: ${borders.standard};
    color: ${colors.black};
  }
`;
